import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';

const CustomerSearchBar = ({ value, onChange, onClear }) => {
  const inputRef = useRef(null);

  return (
    <div className="relative">
      <div className="flex items-center gap-2 bg-muted/60 border border-border rounded-2xl px-4 py-3">
        <Icon name="Search" size={18} className="text-muted-foreground flex-shrink-0" />
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={e => onChange(e?.target?.value)}
          placeholder="Search customers, contacts..."
          className="flex-1 bg-transparent text-sm text-foreground placeholder:text-muted-foreground outline-none min-w-0"
        />
        {value && (
          <button
            onClick={() => { onClear(); inputRef?.current?.focus(); }}
            className="w-5 h-5 rounded-full bg-muted-foreground/30 flex items-center justify-center flex-shrink-0"
          >
            <Icon name="X" size={12} className="text-foreground" />
          </button>
        )}
      </div>
    </div>
  );
};

export default CustomerSearchBar;
